import { render, staticRenderFns } from "./files-base.vue?vue&type=template&id=bf60f3ec&"
import script from "./files-base.vue?vue&type=script&lang=ts&"
export * from "./files-base.vue?vue&type=script&lang=ts&"
import style0 from "./files-base.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports